export const NEXT_REPONSES = {
    NOT_FOUND_R0: { notFound: true },
    NOT_FOUND_R10: { notFound: true, revalidate: 10 },
    NOT_FOUND_R100: { notFound: true, revalidate: 100 },
    NOT_FOUND_R300: { notFound: true, revalidate: 300 },
    NOT_FOUND_R3000: { notFound: true, revalidate: 3000 },
}
